@if (academicYears?.length) {
  <div class="container">
    @if (label) {
      <label [for]="identifier">{{ label }}</label>
    }
    @if (hasError) {
      <p class="error-message"><app-lu-icon icon="alert-circle"></app-lu-icon> <ng-content></ng-content></p>
    }
    <select name="academic-year-selector" [(ngModel)]="value" id="identifier" [compareWith]="equals" [disabled]="disabled">
      <option [ngValue]="null">{{ placeholder }}</option>
      @for (year of academicYears; track year) {
        <option [ngValue]="year">{{ year.acyrCode | academicYearCode }}</option>
      }
    </select>
  </div>
}
